"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactFlexbox = _interopRequireDefault(require("react-flexbox"));
var _formatFlexAlign = require("../../utils/formatFlexAlign");
var _excluded = ["className", "style", "theme", "testId", "children", "wrap", "auto", "debug"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  debug: false,
  theme: {}
};
function mixingDebugMode() {
  // add outlines for flexbox debugging
  return {
    background: "#".concat(Math.floor(Math.random() * 16777215).toString(16)),
    outline: '3px solid #F2BE24'
  };
}

/**
 * Used for displaying flex column container.
 * <br><i>Warning: This component will be deprecated in a future version of anypoint-components</i>
 */
var Column = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Column, _React$Component);
  function Column() {
    (0, _classCallCheck2["default"])(this, Column);
    return _callSuper(this, Column, arguments);
  }
  (0, _createClass2["default"])(Column, [{
    key: "getFlexAlignment",
    value: function getFlexAlignment() {
      var align = this.props.align;
      /* default alignment for Row  */
      var defaultAlignment = ['left', 'top'];
      var alignment = align ? align.split(' ') : defaultAlignment;
      var horizontal = alignment[0];
      var vertical = alignment[1];
      return [(0, _formatFlexAlign.formatHorizontalFlex)(horizontal), (0, _formatFlexAlign.formatVerticalFlex)(vertical)];
    }
  }, {
    key: "getFlexStyle",
    value: function getFlexStyle() {
      var style = this.props.style;
      var horizontal = this.getFlexAlignment()[0];
      var vertical = this.getFlexAlignment()[1];

      // Do mapping specifically for column style
      var defaultflexBasis = style && style.flexBasis ? style.flexBasis : 'initial';
      var columnVert = vertical === 'stretch' ? 'space-between' : vertical;
      return {
        alignItems: horizontal,
        justifyContent: columnVert,
        flexBasis: defaultflexBasis
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        theme = _this$props.theme,
        testId = _this$props.testId,
        children = _this$props.children,
        wrap = _this$props.wrap,
        auto = _this$props.auto,
        debug = _this$props.debug,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var emptyObject = {};
      var flexStyle = this.getFlexStyle();
      var wrapStyle = wrap ? {
        flexWrap: 'wrap'
      } : emptyObject;
      var debugMode = debug ? mixingDebugMode() : emptyObject;
      var mergeStyles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, flexStyle), wrapStyle), style), debugMode);

      // unnecesary props
      delete other.align;
      return /*#__PURE__*/_react["default"].createElement(_reactFlexbox["default"], (0, _extends2["default"])({}, other, {
        className: (0, _classnames["default"])(className, theme.column, 'flex-column'),
        "data-test-id": testId,
        "data-anypoint-component": Column.displayName,
        style: mergeStyles,
        auto: auto,
        column: true
      }), children);
    }
  }]);
  return Column;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Column, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Column, "displayName", 'Column');
//# sourceMappingURL=Column.js.map